import { NeonErrorPageContent } from '@ps-refarch-ux/neon';
import { Outlet } from 'react-router-dom';
import { isDistrictCourseCatalogScope } from '@/utils/cp-context';
import { isSchoolIndividualCoursePlannerProductLevel } from '@/utils/succeed-course-planner-product-level-cache';

/** Restricts the Subject Areas route to district-level course catalog scope. */
export function SubjectAreasGate() {
  const isDistrictScope =
    isDistrictCourseCatalogScope() && !isSchoolIndividualCoursePlannerProductLevel();
  if (!isDistrictScope) {
    return (
      <NeonErrorPageContent
        dataErrorCode="403"
        dataHeading="Access denied"
        dataShowErrorCode={true}
      />
    );
  }

  return <Outlet />;
}
